export const ADMIN_ROLES = ['system_admin', 'super_admin', 'super_system_user'];

export const isAdminRole = (role?: string | null) => {
  if (!role) return false;
  return ADMIN_ROLES.includes(role);
};
